import React, { Component } from 'react';

import './styles/modalErrorAge.scss';

export default class ModalErrorAge extends Component {
  render() {
    return (
      <div className="modal-error">
        <div className="modal-error__text">
          {this.props.modalInfo.type === 'default' ? <p>Самостоятельное приобретение клубной карты FITRON доступно только с 18 лет. Детские и teen-карты оформляются родителем</p> : ''}
          {this.props.modalInfo.type === 'student' ? <p>Приобретение студенческой карты доступно только до 24 лет</p> : ''}
          {this.props.modalInfo.type === 'youth' ? <p>Приобретение молодёжной карты доступно только с 15 до 18 лет</p> : ''}
          {this.props.modalInfo.type === 'testdrive' ? <p>Тест-драйв может приобрести клиент строго 15+</p> : ''}
          <a href="/" className="btn _type-2">Понятно</a>
        </div>
      </div>
    )  
  }
}